(() => {
  if (window.shyUXFoundation) return;
  window.shyUXFoundation = true;
  const body = document.body;
  const header = document.querySelector('.header');
  let compactThreshold = 0;
  function fitHeader() {
    if (!header) return;
    const menu = header.querySelector('.header__inline-menu');
    if (!menu) return;
    const logo = header.querySelector('.header__heading');
    const icons = header.querySelector('.header__icons');
    const visible = getComputedStyle(menu).display !== 'none';
    if (visible) {
      const style = getComputedStyle(header);
      compactThreshold = menu.scrollWidth + (logo?.getBoundingClientRect().width || 120) + (icons?.getBoundingClientRect().width || 132) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 16;
    }
    const enlarged = parseFloat(getComputedStyle(document.documentElement).fontSize) > 15;
    body.classList.toggle('header-compact', window.innerWidth >= 990 && (header.clientWidth < compactThreshold || enlarged));
  }
  function syncOverlays() {
    const open = document.querySelector('header details[open], .mobile-facets__disclosure[open], dialog[open], .product-media-modal[open]');
    body.classList.toggle('ux-overlay-open', Boolean(open));
  }
  const observer = new MutationObserver(syncOverlays);
  observer.observe(body, {subtree:true, attributes:true, attributeFilter:['open']});
  /* Contact stays available without covering prices, form fields or primary actions. */
  let collisionFrame = 0;
  function syncContactCollision() {
    collisionFrame = 0;
    const floating = document.querySelector('.shy-floating-contact');
    if (!floating || getComputedStyle(floating).display === 'none') {
      body.classList.remove('ux-contact-obscured');
      return;
    }
    const targets = [...document.querySelectorAll('main .price, main .totals, main input:not([type=hidden]), main select, main textarea, main button, main .button, main[data-template=index] :is(.shy-need__card, .shy-category__card, .shy-sample-kits__card)')];
    if (matchMedia('(min-width:750px)').matches) {
      targets.push(...document.querySelectorAll('main .shy-need__card, main .shy-collection-index .collection-list__item, main .shy-med-sub__features--routes .shy-med-sub__card, main .shy-medical-cap__card, main .shy-medical-cap__visual-copy, main .shy-cap-comparison > summary, main .shy-medical-cap__table-wrap'));
    }
    const links = [...floating.querySelectorAll('a')].map(link => link.getBoundingClientRect()).filter(r => r.width > 0 && r.height > 0);
    const obscures = [...targets].some(target => {
      const style = getComputedStyle(target), r = target.getBoundingClientRect();
      if (style.visibility === 'hidden' || r.width <= 0 || r.height <= 0 || r.bottom <= 0 || r.top >= innerHeight) return false;
      return links.some(link => r.left < link.right && r.right > link.left && r.top < link.bottom && r.bottom > link.top);
    });
    body.classList.toggle('ux-contact-obscured', obscures);
  }
  function requestCollisionCheck() {
    if (!collisionFrame) collisionFrame = requestAnimationFrame(syncContactCollision);
  }
  window.addEventListener('scroll', requestCollisionCheck, {passive:true});
  window.addEventListener('resize', requestCollisionCheck, {passive:true});
  document.addEventListener('focusin', requestCollisionCheck);
  document.addEventListener('toggle', requestCollisionCheck, true);
  window.addEventListener('load', requestCollisionCheck, {once:true});
  const main = document.querySelector('main');
  if (main) {
    new MutationObserver(requestCollisionCheck).observe(main, {childList:true, subtree:true});
    main.addEventListener('load', requestCollisionCheck, true);
  }
  window.addEventListener('resize', fitHeader, {passive:true});
  document.addEventListener('shopify:section:load', () => { fitHeader(); syncOverlays(); requestCollisionCheck(); });
  document.fonts?.ready.then(() => { fitHeader(); requestCollisionCheck(); });
  fitHeader(); syncOverlays(); requestCollisionCheck();
  /* Native disclosure stays operable without JavaScript; expand link groups on desktop. */
  const mq = matchMedia('(min-width:750px)');
  function syncFooter() {
    document.querySelectorAll('.shy-footer-links details').forEach(d => { d.open = mq.matches; });
  }
  mq.addEventListener('change', syncFooter); syncFooter();
})();
